var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCheckBlack = function SvgCheckBlack(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 11
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.286 4.66 0 6.192l5.362 4.5 7.714-9.193L11.544.214l-6.428 7.66-3.83-3.214Z"
  })));
};
export default SvgCheckBlack;